import PhotoDetailsSection from '../src/PhotoDetailsSection.tsx';
export default PhotoDetailsSection;
